import { useMemo, useState } from "react";
import httpClient from "../../../custom-hooks/httpClient";
import { toast } from "react-toastify";
import Modal from "../../Modal";
import { BeneficiaryList, ConfirmDeleteModal } from "./Shared";

function BankBeneficiariesModal({
  beneficiaries,
  setBeneficiaries,
  handleBeneficiarySelection,
  showModal,
  setShowModal,
  banks = [],
}) {
  const [confirmDeleteId, setConfirmDeleteId] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");

  // Lookup of bank code -> bank name, built once per bank list.
  // Codes are trimmed because a few in the bank list have trailing spaces.
  const bankNamesByCode = useMemo(
    () => new Map(banks.map((bank) => [bank.code?.trim(), bank.name?.trim()])),
    [banks],
  );

  const handleConfirmDelete = async () => {
    try {
      const { status, data } = await httpClient.delete(
        `/beneficiaries/${confirmDeleteId}`,
      );
      if (status === 200) {
        setBeneficiaries((prevBeneficiaries) =>
          prevBeneficiaries.filter((b) => b.id !== confirmDeleteId),
        );
        toast.success(data.message || "Beneficiary deleted successfully!");
        setConfirmDeleteId(null);
      }
    } catch (err) {
      toast.error(err.response?.data.message || "Error deleting beneficiary!");
      setConfirmDeleteId(null);
    }
  };

 // Bank beneficiaries only (those with a bank code).
  const filterBeneficiaries = beneficiaries.filter((b) => Boolean(b.bank_code));

  return (
    <Modal
      showModal={showModal}
      setShowModal={setShowModal}
      title=""
      showTitle={false}
      clickOut={true}
      noPadding
    >
      <BeneficiaryList
        beneficiaries={filterBeneficiaries}
        searchQuery={searchQuery}
        onSearchChange={setSearchQuery}
        onClose={() => setShowModal(false)}
        onSelect={handleBeneficiarySelection}
        onDelete={setConfirmDeleteId}
        getSubLabel={(b) => {
          const bankName = bankNamesByCode.get(b.bank_code?.trim());
          return `${bankName ? `${bankName} · ` : ""}${b.recipient_account_number}`;
        }}
      />

      <ConfirmDeleteModal
        confirmDeleteId={confirmDeleteId}
        beneficiaries={beneficiaries}
        onCancel={() => setConfirmDeleteId(null)}
        onConfirm={handleConfirmDelete}
      />
    </Modal>
  );
}

export default BankBeneficiariesModal;
